<template>
  <step-component :initStepper="stepper" :steps="steps" @stepperUpdated="onStepperUpdated">
    <template v-slot:step-1>
      <div style="padding: 8px">
        <b-card class="sa-card sa-card-border" header="Setting Paziente" header-tag="header" footer-tag="footer"
          title="">
          <b-row class="sa-padding-left text-left"
            style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 0.5rem">
            <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <div role="">
                <label class="sa-label-data">Regime<span style="color: red">*</span></label>
                <b-form-select v-model="localData.regime" placeholder="Seleziona Regime" :options="regimiOptions"
                  value-field="codice" text-field="descrizione" @change="emitChange()">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <div role="">
                <label class="sa-label-data">Setting<span style="color: red">*</span></label>
                <b-form-select v-model="localData.idSetting" placeholder="Seleziona Regime"
                  @change="onChangePresidioSetting">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                  <b-form-select-option v-for="option in settingsOptions" :value="option.idRsaSettings"
                    :key="option.id">
                    {{ option.setting }}</b-form-select-option>
                </b-form-select>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <div role="">
                <label class="sa-label-data">Livello<span style="color: red">*</span></label>
                <b-form-select v-model="localData.idSettingLivello" placeholder="Seleziona Regime"
                  :options="settingLivelliOptions" value-field="id" text-field="descrizione" @change="emitChange()">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </b-col>
          </b-row>
        </b-card>
        <accettazione-ssn-anagrafica-component :jsonData="jsonData" :isEdit="isEdit"
          :isDematerializzata="isDematerializzata" :tipologiaRicetta="tipologiaRicetta"
          @changeJsonData="onChangeAccettazioneAnagraficaJSON" @beforeLoadData="onBeforeLoadData"
          @afterLoadData="onAfterLoadData" />
        <b-card class="sa-card sa-card-border" header="Altre informazioni" header-tag="header" footer-tag="footer"
          title="">
          <b-row class="sa-padding-left text-left"
            style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 0.5rem">
            <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <div role="statocivileselect">
                <label class="sa-label-data">Stato Civile <span style="color: red">*</span></label>
                <b-form-select :disabled="!isEdit || (isDematerializzata && isConfermaAnagrafica)"
                  v-model="localData.statoCivile" placeholder="Inserisci Stato Civile" :options="statoCivileOptions"
                  value-field="descrizione" text-field="descrizione" @change="emitChange()">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <div role="cittadinanzaselect">
                <label class="sa-label-data">Cittadinanza</label>
                <b-form-select :disabled="!isEdit || (isDematerializzata && isConfermaAnagrafica)"
                  v-model="localData.cittadinanza" placeholder="Inserisci Cittadinanza" :options="cittadinanzeOptions"
                  @change="emitChange()">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <div role="partitaIvainput">
                <label class="sa-label-data">Partita Iva</label>
                <b-form-input :disabled="!isEdit || (isDematerializzata && isConfermaAnagrafica)"
                  v-model="localData.partitaIva" placeholder="Inserisci PartitaIva" @input="emitChange()">
                </b-form-input>
              </div>
            </b-col>

            <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <div role="tipologiedocumentoselect">
                <label class="sa-label-data">Tipologia Documento </label>
                <b-form-select :disabled="!isEdit || (isDematerializzata && isConfermaAnagrafica)"
                  v-model="localData.tipologiaDocumento" placeholder="Scegli tipologia Documento"
                  :options="tipologiaDocumentoOptions" @change="emitChange()">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <div role="documentoinput">
                <label class="sa-label-data">Documento </label>
                <b-form-input :disabled="!isEdit || (isDematerializzata && isConfermaAnagrafica)" @input="emitChange()"
                  v-model="localData.documento" placeholder="Inserisci Documento">
                </b-form-input>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <div role="rilasciatoDaselect">
                <label class="sa-label-data">Rilasciato Da </label>
                <b-form-select :disabled="!isEdit || (isDematerializzata && isConfermaAnagrafica)"
                  @change="emitChange()" v-model="localData.rilasciatoDa"
                  placeholder="Scegli istituzione rilascio documento" :options="rilasciatoDaOptions">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
              <div role="rilasciatoDaselect">
                <label class="sa-label-data">Scadenza Tessera</label>
                <date-picker format="DD/MM/YYYY" value-type="timestamp" placeholder="Inserisci Data Scadenza Tessera"
                  :disabled="!isEdit" v-model="localData.scadenzaTessera" @input="emitChange()"
                  type="date"></date-picker>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <label class="sa-label-data">Note Caratteristiche Paziente</label>
              <b-form-textarea v-model="localData.noteCaratteristichePaziente" placeholder="Inserisci Note su Paziente "
                @input="emitChange()" rows="3" :disabled="!isEdit" max-rows="6"></b-form-textarea>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </template>
    <template v-slot:step-2>
      <accettazione-ssn-impegnativa-component :isEdit="isEdit" :jsonData="jsonData" :ricette="jsonData.ricette"
        :isDematerializzata="isDematerializzata" @isTipologiaDematerilizzata="onIsTipologiaDematerilizzata"
        @onOpenModalImpegnativa="onOpenModalImpegnativa" @beforeLoadData="onBeforeLoadData"
        @afterLoadData="onAfterLoadData" @onAggiungiImpegnativa="onAggiungiImpegnativa"
        @updateJsonRicette="onChangeAccettazioneImpegnativa" @reload="onReload" :key="keyList" />
      <!-- @changeJsonData="onChangeAccettazioneImpegnativa" -->
    </template>
    <template v-slot:step-3>
      <b-row>
        <b-col cols="12">
          <b-table sticky-header ref="table" stacked="lg" striped hover :items="jsonData.ricette"
            :fields="fieldImpegnativeDettaglio" :current-page="1" :per-page="10" sort-icon-left head-variant="light"
            class="sa-b-table">
            <template #cell(nre)="row"> {{ row.item.codiceBar1 }}{{ row.item.codiceBar2 }} </template>
            <template #cell(importoTotale)="row">
              <span>{{ calcolaImportoTotale(row) }}€</span>
            </template>
            <template #cell(prestazioniTotali)="row">
              <span>{{ row.item.prestazioni.length }}</span>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </template>
  </step-component>
</template>

<script>
/* eslint-disable */

import AccettazioneSsnRicettaComponent from "./AccettazioneSsnRicettaComponent.vue";
import UtilityMixin from "../../../utility/UtilityMixin.js";
import DatePicker from "vue2-datepicker";
import AccettazioneSsnRicettaEditModalComponent from "./AccettazioneSsnRicettaViewModalComponent.vue";
import AccettazioneSsnRicettaPrestazioniComponent from "./AccettazioneSsnRicettaPrestazioniComponent.vue";
import AccettazioneSsnImpegnativaComponent from "./AccettazioneSsnImpegnativaComponent.vue";
import AccettazioneSsnAnagraficaComponent from "./AccettazioneSsnAnagraficaComponent.vue";
import StepComponent from "../../ssn/utility/StepComponent"
import FormIndirizzoComponent from "../../ssn/utility/FormIndirizzoComponent.vue";
export default {
  components: {
    AccettazioneSsnRicettaComponent,
    AccettazioneSsnRicettaPrestazioniComponent,
    AccettazioneSsnAnagraficaComponent,
    AccettazioneSsnRicettaEditModalComponent,
    AccettazioneSsnImpegnativaComponent,
    DatePicker,
    StepComponent,
    FormIndirizzoComponent,
  },
  mixins: { UtilityMixin },
  props: {
    isEdit: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    tipologiaRicetta: {
      type: String,
      required: false,
      default: () => {
        return null;
      },
    },
    isDematerializzata: {
      type: Boolean,
      required: true,
      default: () => {
        return false;
      },
    },
    isFirstDematerializzata: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
    jsonData: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      isConfermaAnagrafica: false,
      pathResource: "/gestionericette",
      stepper: 1,
      linkRegimi: "/accettazioneregimi",
      keyList: 0,
      keyAnagrafica: 0,
      statoCivileOptions: [],
      settingLivelliOptions: [],
      pathResourceSettingsPresidi: "/rsasettingspresidi",
      pathResourceRsaSettingLivelli: "/rsasettinglivelli",
      regimiOptions: [],
      steps: ["Anagrafica", "Impegnativa", "Riepilogo"],
      tipologiaDocumentoOptions: ["Carta d'identita'", "Passaporto", "Patente di guida"],
      rilasciatoDaOptions: ["Ministero dell'Interno", "IPZS", "Comuni", "Polizia di Stato", "Altre Pubbliche Amministrazioni"],
      localData: {
        regime: 'AMBULATORIALE',
        idSetting: null,
        settingCodice: null,
        settingDescrizione: null,
        idSettingLivello: null,
        descrizioneLivello: null,
        cittadinanza: null,
        statoCivile: null,
        anonimato: true,
        stp: false,
        eni: true,
        conv: false,
        team: true,
        emailBox: true,
        sconosciuto: false,
        noteCaratteristichePaziente: null,
        rilasciatoDa: null,
        documento: null,
        partitaIva: null,
        identificazioneIstituzione: null,
        tipologiaDocumento: null,
        identificazioneTessera: null,
        scadenzaStpEni: 0,
        scadenzaTessera: null,
        note: "",
      },
      fieldImpegnativeDettaglio: [
        {
          label: "NRE",
          key: "nre",
        },
        {
          label: "C.F Assistito",
          key: "codiceFiscaleAssistito",
        },
        {
          label: "Priorita",
          key: "classePriorita",
        },

        {
          label: "Importo Totale",
          key: "importoTotale",
        },
      ],
      settingsOptions: [],
      cittadinanzeOptions: [
        { text: "Italiana", value: "ITALIANA" },
        { text: "Francese", value: "FRANCESE" },
        { text: "Tedesca", value: "TEDESCA" },
        { text: "Spagnola", value: "SPAGNOLA" },
        { text: "Portoghese", value: "PORTOGHESE" },
        { text: "Greca", value: "GRECA" },
        { text: "Olandese", value: "OLANDESE" },
        { text: "Belga", value: "BELGA" },
        { text: "Svedese", value: "SVEDERE" },
        { text: "Norvegese", value: "NORVEGESE" },
        { text: "Danese", value: "DANESE" },
        { text: "Finlandese", value: "FINLANDESE" },
        { text: "Polacca", value: "POLACCA" },
        { text: "Ceca", value: "CECA" },
        { text: "Ungherese", value: "UNGHERESE" },
        { text: "Rumena", value: "RUMENA" },
        { text: "Bulgara", value: "BULGARA" },
        { text: "Croata", value: "CROATA" },
        { text: "Slovena", value: "SLOVENA" },
        { text: "Austriaca", value: "AUSTRIACA" },
        { text: "Svizzera", value: "SVIZZERA" },
        { text: "Statunitense", value: "STATUNITENSE" },
        { text: "Canadese", value: "CANADESE" },
        { text: "Messicana", value: "MESSICANA" },
        { text: "Brasiliana", value: "BRASILANA" },
        { text: "Argentina", value: "ARGENTINA" },
        { text: "Cinese", value: "CINESE" },
        { text: "Giapponese", value: "GIAPPONESE" },
        { text: "Indiana", value: "INDIANA" },
        { text: "Australiana", value: "AUSTRALIANA" },
        { text: "Marocchina", value: "MAROCCHINA" },
        { text: "Egiziana", value: "EGIZIANA" },
        { text: "Sudafricana", value: "SUDAFRICANA" },
        { text: "Russa", value: "RUSSA" },
        { text: "Ucraina", value: "UCRAINA" },
        { text: "Turca", value: "TURCA" },
        { text: "Coreana", value: "COREANA" },
      ],
    };
  },
  computed: {},
  mounted() {
    let me = this;
    me.onLoadStatiCivili();
    this.loadRegimi();
    me.localData = { ...this.jsonData };
    me.setLocalData(this.jsonData);
    if (me.tipologiaRicetta != null) {
      me.localData.tipologiaRicetta = me.tipologiaRicetta;
    }




    me.keyList++;
  },
  methods: {
    onLoadStatiCivili() {
      let me = this;
      me.statoCivileOptions = [];
      UtilityMixin.methods.loadDataResources("/anagraficastaticivili", {}, me.onLoadStatiCiviliSuccess, me.onLoadStatiCiviliError);
    },
    onLoadStatiCiviliSuccess(response) {
      let me = this;

      me.statoCivileOptions = response.data.data.list;
    },
    onLoadStatiCiviliError(err) {
      err;
    },
    onStepperUpdated(params) {
      this.$emit("stepperUpdated", params);
    },
    onBeforeLoadData() {
      let me = this;
      me.$emit("beforeLoadData");
      me.$bvToast.toast("Errore durante il caricamento", {
        title: "Errore",
        variant: "danger",
        solid: true,
      });
    },
    onChangeRsaSettingLivelli(value) {
      let me = this;
      me.settingLivelliOptions.forEach((element) => {
        if (element.id === value) {
          me.localData.descrizioneLivello = element.descrizione;
          me.localData.settingCodice = element.codice;
        }
      });
      this.loadDataSettingLivelli(value);
    },
    loadRegimi() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.linkRegimi, null, me.loadRegimiSuccess, me.loadRegimiError);
    },
    loadRegimiSuccess(response) {
      let me = this;
      me.regimiOptions = response.data.data.list;
    },
    loadRegimiError(error) {
      console.log(error);
    },
    loadSettingsPresidi(id) {
      let me = this;
      me.settingsOptions = [];
      let params = { idPresidio: id };
      UtilityMixin.methods.loadDataResources(me.pathResourceSettingsPresidi, params, me.resultResponseSettings, me.resultErrorSettings);
    },
    resultResponseSettings(response) {
      let me = this;
      me.settingsOptions = response.data.data.list;
      if (me.settingsOptions.length === 1) {
        me.localData.settingCodice = me.settingsOptions[0].codice;
        me.localData.settingDescrizione = me.settingsOptions[0].setting;
      }
    },
    onChangePresidioSetting(codice) {
      console.log(codice);

      this.settingsOptions.forEach((element) => {
        if (element.idRsaSettings === codice) {
          this.localData.settingDescrizione = element.setting;
        }
      });
      this.emitChange();
      this.loadDataSettingLivelli(codice);
    },

    resultErrorSettings(response) {
      UtilityMixin.methods.messaggeBoxError(this, response);
    },
    onReload() {
      let me = this;
      me.$emit("reload");
    },
    onAfterLoadData() {
      let me = this;
      me.$emit("afterLoadData");
    },
    onConfermaAnagrafica() {
      this.isConfermaAnagrafica = true;
      this.stepper = 2;
    },
    loadDataSettingLivelli(s) {
      let me = this;
      if (s) {
        me.settingLivelliOptions = [];
        UtilityMixin.methods.loadDataResources(me.pathResourceRsaSettingLivelli, { idSetting: s }, me.resultResponseSettingLivelli, null);
      }
    },
    resultResponseSettingLivelli(response) {
      let me = this;

      me.settingLivelliOptions = response.data.data.list;
    },
    onChangeRsaSettingLivelli(value) {
      let me = this;
      me.settingLivelliOptions.forEach((element) => {
        if (element.id === value) {
          me.localData.descrizioneLivello = element.descrizione;
        }
      });
    },

    onOpenModalImpegnativa() {
      let me = this;
      me.$emit("onOpenModalImpegnativa");
    },
    onClickBtnStruttura() {
      this.$emit("onOpenModalStruttura");
    },
    onIsTipologiaDematerilizzata(value) {
      let me = this;
      me.$emit("isTipologiaDematerilizzata", value);
    },
    onChangeStrutturaJSON(json) {
      let me = this;
      me.$emit("changeStruttura", json);
    },
    submit() {
      alert("Form inviato!");
    },
    calcolaImportoTotale(row) {
      let totale = 0;
      if (row.item.prestazioni) {
        for (let pre of row.item.prestazioni) {
          totale += pre.prezzo;
        }
      }
      return totale;
    },
    setLocalData(json) {

      console.log(json.accettazione.regime);

      let me = this;
      me.localData.noteCaratteristichePaziente = json.noteCaratteristichePaziente;
      me.localData.statoCivile = json.statoCivile;
      me.localData.cittadinanza = json.cittadinanza;
      me.localData.partitaIva = json.partitaIva;
      me.localData.tipologiaDocumento = json.tipologiaDocumento;
      me.localData.documento = json.documento;
      me.localData.rilasciatoDa = json.rilasciatoDa;
      me.localData.scadenzaTessera = json.scadenzaTessera;
      me.localData.regime = json.accettazione.regime;
      me.localData.idSetting = json.accettazione.idSetting;
      me.localData.idSettingLivello = json.accettazione.idSettingLivello;
    },
    emitChange() {
      let me = this;
      me.$emit("changeJsonAccettazioneSsn", me.localData);
    },
    onChangeAccettazioneImpegnativa(ricette) {
      this.$emit("changeJsonDataImpegnative", ricette);
    },
    onAggiungiImpegnativa(json, jsonIntegrazione) {
      let me = this;
      console.log("emitjsonIntegrazione", jsonIntegrazione);

      me.$emit("onAggiungiImpegnativa", json);
    },

    onChangeAccettazioneAnagraficaJSON(json) {
      let me = this;
      me.localData.accettazione.accettazioneAnagrafica = {
        id: json.id,
        primaryKey: json.primaryKey,
        tipo: json.tipo,
        idAccettazione: json.idAccettazione,
        identificativo: json.identificativo,
        tipoIdentificativo: "CF",
        cognome: json.cognome,
        nome: json.nome,
        dataNascita: json.dataNascita,
        sesso: json.sesso,
        provinciaNascita: json.provinciaNascita,
        comuneNascitaCodiceIstat: json.comuneNascitaCodiceIstat,
        regioneNascita: json.regioneNascita,
        telefono: json.telefono,
        email: json.email,
        regioneResidenza: json.regioneResidenza,
        provinciaResidenza: json.provinciaResidenza,
        comuneResidenzaCodiceIstat: json.comuneResidenzaCodiceIstat,
        indirizzoResidenza: json.indirizzoResidenza,
        capResidenza: json.capResidenza,
        regioneDomicilio: json.regioneDomicilio,
        provinciaDomicilio: json.provinciaDomicilio,
        comuneDomicilioCodiceIstat: json.comuneDomicilioCodiceIstat,
        indirizzoDomicilio: json.indirizzoDomicilio,
        capDomicilio: json.capDomicilio,
        gruppoSanguigno: json.gruppoSanguigno,
        createDate: json.createDate,
        createUser: json.createUser,
        proprietario: json.proprietario,
      };
      me.localData.accettazione.accettazioniAsl = {
        aslDomicilioAmbito: json.aslDomicilioAmbito,
        aslDomicilioCodice: json.aslDomicilioCodice,
        aslDomicilioDenominazione: json.aslDomicilioDenominazione,
        aslDomicilioDistretto: json.aslDomicilioDistretto,
        aslResidenzaAmbito: json.aslResidenzaAmbito,
        aslResidenzaCodice: json.aslResidenzaCodice,
        aslResidenzaDenominazione: json.aslResidenzaCodice,
        aslResidenzaDistretto: json.aslResidenzaDistretto,
      };
      me.$emit("changeJsonDataAnagrafica", me.localData.accettazione);
    },
  },
  watch: {

    stepper: {
      handler(value) {
        console.log(value);
      },
      deep: true,
      immediate: true,
    },
    jsonData: {
      handler(json) {
        let me = this;
        me.setLocalData(json);
        console.log(json);
        if (json.accettazione.idPresidio) {
          this.loadSettingsPresidi(json.accettazione.idPresidio)
        }

      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped>
.active-class-step {
  border: 2px solid rgb(21, 155, 207) !important;
  background-color: white;
  border-radius: 50%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgb(21, 155, 207) !important;
  box-shadow: 0 0 10px rgba(21, 155, 207, 0.3);
  transition: all 0.2s ease-in-out;
}

.ft-step {
  font-weight: 700;
  font-size: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f0f0f0;
  color: #555;
  margin: 10px;
  transition: all 0.3s ease-out;
  margin-bottom: 25px;
}
</style>
